module.exports = __webpack_public_path__ + "static/media/sun.db228ddf.webp";